import React, { useState } from "react";
import { CancelButton, SaveButton, DrawerComponent } from "@comps/components";
import { makeRequest, notify } from "@utils/helpers";
import { createCaseStatusReq } from "../requests";
import CaseStatusForm from "./CaseStatusForm";

const formName = "caseStatuss";
const CreateCaseStatus = (props) => {
  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState([]);

  const onFinish = (data) => {

    let payload = {
      "object": {
        name: data.name,
        is_active: true,
        order: data.order,
        description: data.description,
      }
    }
    makeRequest(setLoader, createCaseStatusReq, payload, onSuccess, onError);
  }

  const onSuccess = (data, res) => {
    notify("CaseStatus Created", res.msg);
    props.onCreated(data.object);
  }

  const onError = (data) => {
    setErrors(data);
  }

  return (
    <DrawerComponent mainTitle="Create" subTitle="Case Status" open={ true } footer={ false } onClose={ () => props.onClosed(false) }>
      <CaseStatusForm setErrors={ setErrors } errors={ errors } onFinish={ onFinish } formName={ formName } />
      <div className="form-actions">
        <CancelButton key="close_button" onClick={ () => props.onClosed(false) } />
        <SaveButton form={ formName } key="create_button" htmlType="submit" state={ loader } />
      </div>
    </DrawerComponent>
  );
}

export default CreateCaseStatus
